
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.812 16.276"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 6935","d":"M16.6 7.941a.8.8 0 00-.066-1.147L9.022.22A.937.937 0 007.8.234L.261 7.145A.8.8 0 00.225 8.29l.189.2a.824.824 0 001.131.087l.563-.5v7.387a.82.82 0 00.82.82h2.94a.82.82 0 00.82-.82v-5.176h3.748v5.168a.775.775 0 00.77.82h3.114a.82.82 0 00.82-.82V8.173l.348.305c.192.168.594.033.9-.3z","fill":"#21afff"}})])
          )
        }
      }
    